/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DayCount
 */
export interface DayCount {
    /**
     * 
     * @type {string}
     * @memberof DayCount
     */
    day: string;
    /**
     * 
     * @type {number}
     * @memberof DayCount
     */
    count: number;
}

/**
 * Check if a given object implements the DayCount interface.
 */
export function instanceOfDayCount(value: object): value is DayCount {
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function DayCountFromJSON(json: any): DayCount {
    return DayCountFromJSONTyped(json, false);
}

export function DayCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayCount {
    if (json == null) {
        return json;
    }
    return {
        
        'day': json['day'],
        'count': json['count'],
    };
}

export function DayCountToJSON(json: any): DayCount {
    return DayCountToJSONTyped(json, false);
}

export function DayCountToJSONTyped(value?: DayCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'day': value['day'],
        'count': value['count'],
    };
}

